import React, { useLayoutEffect, useRef, useState, useEffect } from "react";
import { Space, Input, Dropdown, Table, Tag, Menu, Flex } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { ProgressSpinner } from "primereact/progressspinner";
import { DownOutlined } from "@ant-design/icons";
import { render } from "@testing-library/react";
import { Button, Modal } from "antd";
import GlobalVariable from "../../../../client/src/services/globalVar";
import salesService from "../../services/sales-service";
import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { Dropdown as Primedropdown } from "primereact/dropdown";
import { Tooltip } from "antd";
import { IcomoonReact, iconSet } from "../PrimeReact";
import { Dialog } from "primereact/dialog";
import ReceiptVoucherForm from "./ReceiptVoucherForm";
import jsPDF from 'jspdf';
import 'jspdf-autotable'; 
import InvoiceService from "../../../../client/src/services/invoice-service";
import purchaseService from "../../services/purchase-sevice";
import * as XLSX from "xlsx";


const ReceiptVoucher = () => {
  const ss = new salesService();
  const is = new InvoiceService();
  const ps = new purchaseService();
//  useEffect(() => {
//     // Cleanup on unmount
//     return () => {
//       Object.values(is.controllers).forEach((c) => c.abort());
//       is.controllers = {};

//       Object.values(ps.controllers).forEach((c) => c.abort());
//       ps.controllers = {};

//       Object.values(ss.controllers).forEach((c) => c.abort());
//       ss.controllers = {};
//     };
//   }, []);
  const [isProcess, setIsProcess] = useState(false);
  const [invoiceModelPop, setInvoiceModelPop] = useState(false);
  const [isHideCreditGrid, setIsHideCreditGrid] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [viewRowData, setViewRowData] = useState([]);
  // const [paymentVoucher, setPaymentVoucher] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [sortName, setSortName] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [searchVal, setSearchVal] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [isPaymentVoucher, setIsPaymentVoucher] = useState(false);
  const [isView, setIsView] = useState(false);
  const [first1, setFirst1] = useState(0);
  const [isDwn, setIsDwn] = useState();
  const { Column, ColumnGroup } = Table;
  const [tenantDetails, setTenantDetails] = useState({});
  const [summaryval, setSummaryval] = useState([]);



  const [lazyParams, setLazyParams] = useState({
      first: first1,
      rows: sizePerPage,
      page: page,
      sortField: sortName,
      sortOrder: sortOrder,
    });
  const onCustomPage1 = (event) => {
      setFirst1(event.first);
      const val = event.page + 1;
      const size = event.rows;
      setSizePerPage(size);
      setPage(val);
    };
  
    const onSort = (event) => {
      setLazyParams(event);
    };

    const GetContactPaymentListSearch = (
      page,
      sizePerPage,
      searchVal,
      sortName,
      sortOrder,
      
    ) => {
      setIsProcess(true);
      const data = {
        InputParams: {
          TenantID: GlobalVariable.userDet.tenantDetail.tenantID,
          ContactID: 0,
          "Type" : "Vendor",
          Status: "",
        },
        ServerSearchables: {
          draw: 1,
          searchData: searchVal || "",
          orderByColumn: sortName,
          orderBy: sortOrder,
          currentPage: 1,
          pageSize: sizePerPage,
          pageNumber: page,
        },
      };
      ss.GetContactPaymentListSearch(data)
        .then((res) => {
          setIsProcess(false);
          setRowData(res.data.data?.contactPaymentList);
          setTotalRecords(res.data.data.serverSearchables.recordsTotal);
        })
        .catch((err) => setIsProcess(false));
    };

    const emptySearch = () => {
      setSearchVal("");
      GetContactPaymentListSearch(1, sizePerPage, "", "", "");
    };
    const keySearch = (e) => {
      const searched = e.target.value;
      setSearchVal(searched);
      if (e.key === "Enter") {
        setPage(1);
        GetContactPaymentListSearch(1, sizePerPage, searched, "", "");
      }
  
      if (e.type === "keyup" && searched === "") {
        GetContactPaymentListSearch(1, sizePerPage, "", "", "");
      }
    };
    const handleBackButtonClick = (r) => {
      setIsPaymentVoucher(false);
    };
    const dateFormBodyTemplate = (rowData) => {
      return (
        <div>
          {format(
            new Date(rowData.paymentDate),
            GlobalVariable.userDet.tenantConfig.dateFormat
          )}
        </div>
      );
    };
const handleRowClick = (event) => {
  setViewRowData(event.data);
  setIsPaymentVoucher(true);
}

  const GetTenantDetails = () => {
    is.GetTenantDetails(GlobalVariable.userDet.tenantDetail.tenantID).then(
      (res) => {
        setTenantDetails(res.data.data);
        // GetCountryTaxName(res.data.data.country);
      }
    );
  };
  const GetPurchaseExpenseSumnmary = () => {
    ps.GetPurchaseExpenseSumnmary(GlobalVariable.userDet.tenantDetail.tenantID).then((res) => {
      setSummaryval(res.data.data);
    }) 
  }
const actionBodyTemplate = (rowData) => {
  return (
    <div style={{ display: "flex", justifyContent: "flex-start" }}>
      <Tooltip target=".pi-eye" content="View Document" position="top" />
      <Tooltip title="View Document">
        <i
          className="pi pi-eye ms-2 icon-tooltip"
          style={{ color: "slateblue", fontSize: "1.3rem" }}
          onClick={(e) => fetchDocuments(e, rowData)}
        ></i>
      </Tooltip>
    </div>
  );
};

function convertNumberToWords(amount) {
  const ones = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
  ];
  const tens = [
    '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
  ];
  const thousands = ['', 'Thousand', 'Million', 'Billion'];

  let word = '';
  let number = Math.floor(amount);
  let fraction = Math.round((amount - number) * 100); // Extract paisa

  if (number === 0) return 'Zero Rupees';

  const chunkify = (num) => {
    const chunks = [];
    while (num > 0) {
      chunks.unshift(num % 1000);
      num = Math.floor(num / 1000);
    }
    return chunks;
  };

  const convertChunk = (chunk) => {
    let chunkWord = '';
    if (chunk >= 100) {
      chunkWord += ones[Math.floor(chunk / 100)] + ' Hundred ';
      chunk %= 100;
    }
    if (chunk >= 20) {
      chunkWord += tens[Math.floor(chunk / 10)] + ' ';
      chunk %= 10;
    }
    if (chunk > 0) {
      chunkWord += ones[chunk] + ' ';
    }
    return chunkWord.trim();
  };

  const chunks = chunkify(number);
  chunks.forEach((chunk, index) => {
    if (chunk > 0) {
      word += convertChunk(chunk) + ' ' + thousands[chunks.length - 1 - index] + ' ';
    }
  });

  word = word.trim();
  word += ' Rupees';

  if (fraction > 0) {
    word += ' and ' + convertChunk(fraction) + ' Paise';
  }

  return word.trim();
}



// const handleDownload = () => {
//   const doc = new jsPDF();

//   doc.setTextColor(255, 255, 255);
//   doc.setFillColor(169, 169, 169);
//   doc.rect(10, 10, 190, 280); 

//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(20); 
//   const headerText = "Receipt Voucher";
//   const headerWidth = doc.getTextWidth(headerText); 
//   const headerX = (doc.internal.pageSize.width - headerWidth) / 2;
//   doc.setTextColor(0, 0, 0); 
//   doc.text(headerText, headerX, 18);

//   doc.setFont("helvetica", "normal");

//   const tenantName = tenantDetails.tenantName.toUpperCase();
//   const tenantAdd = `${tenantDetails.billAddress1}, ${tenantDetails.billAddress2}`;
//   const tenantCty = `${tenantDetails.billCity} - ${tenantDetails.billZipCode} - ${tenantDetails.billCountry}`;
//   const tenantPh = `${tenantDetails.primaryPhone}, ${tenantDetails.email}`;

//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(12);
//   doc.setTextColor(0, 0, 0); 
//   doc.text(tenantName, 20, 30);

//   doc.setFont("times", "normal");
//   doc.setFontSize(12);

//   doc.text(tenantAdd, 20, 35); 
//   doc.text(tenantCty, 20, 40); 
//   doc.text(tenantPh, 20, 45); 

//   doc.setFontSize(12);
//   doc.text("Voucher No:", 20, 60);
//   const voucherNo = isDwn?.contactPaymentCode || "";
//   doc.text(voucherNo, 105, 60, { align: "left" });

//   const voucherNoWidth = doc.getTextWidth(voucherNo);
//   // doc.line(105, 61, 105 + voucherNoWidth, 61); 

//   doc.text("Date:", 20, 70);
//   const voucherDate = new Date().toLocaleDateString();
//   doc.text(voucherDate, 105, 70, { align: "left" });

//   const dateWidth = doc.getTextWidth(voucherDate);
//   // doc.line(105, 71, 105 + dateWidth, 71);

//   doc.text("Amount:", 20, 80);
//   const amountReceived = isDwn?.amountReceievd?.toFixed(2) || "";
//   doc.text(amountReceived, 105, 80, { align: "left" });

//   const amountWidth = doc.getTextWidth(amountReceived);
//   // doc.line(105, 81, 105 + amountWidth, 81); 

//   const amountInWords = convertNumberToWords(isDwn?.amountReceievd || 0);

//   const maxWidth = 80; 
//   const maxLines = 2;
//   const startX = 105;
//   const startY = 90;

//   const wrappedText = doc.splitTextToSize(amountInWords, maxWidth);

//   const twoLines = wrappedText.slice(0, maxLines);

//   doc.text("Amount in Words:", 20, startY);

//   doc.text(twoLines, startX, startY);

//   const firstLineWidth = doc.getTextWidth(twoLines[0]);
//   // doc.line(startX, startY + 1, startX + firstLineWidth, startY + 1);

//   doc.text("Payment Method:", 20, 100);
//   const paymentMethod = isDwn?.paymentMode || "";
//   doc.text(paymentMethod, 105, 100, { align: "left" });

//   const paymentMethodWidth = doc.getTextWidth(paymentMethod);
//   // doc.line(105, 101, 105 + paymentMethodWidth, 101); 

//   doc.text("Amount Paid To:", 20, 110);
//   const amountPaidTo = isDwn?.companyName || "";
//   doc.text(amountPaidTo, 105, 110, { align: "left" });

//   const paidToWidth = doc.getTextWidth(amountPaidTo);
//   // doc.line(105, 111, 105 + paidToWidth, 111); 

//   doc.setFontSize(15);
//   doc.text("Authorized By", 20, 150, { align: "left" });
//   doc.text("Received By", 150, 150, { align: "left" });

//   doc.save("ReceiptVoucher.pdf");
// };

const handleDownload = () => {
  const doc = new jsPDF();

  // Header Section - Company Name
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  const tenantName = tenantDetails?.tenantName?.toUpperCase() || "Tenant Name"; // Dynamic company name
  doc.text(tenantName, 105, 20, { align: "center" });

  // Address Section
  const tenantAdd = `${tenantDetails?.billAddress1}, ${tenantDetails?.billAddress2}` || "";
  const tenantCty = `${tenantDetails?.billCity} - ${tenantDetails?.billZipCode} - ${tenantDetails?.billCountry}` || "";
  const tenantPh = `${tenantDetails?.primaryPhone}, ${tenantDetails?.email}` || "";

  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");
  doc.text(tenantAdd, 105, 28, { align: "center" });
  doc.text(tenantCty, 105, 34, { align: "center" });
  doc.text(tenantPh, 105, 40, { align: "center" });

  // Title Section
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("PAYMENT VOUCHER", 105, 50, { align: "center" });

  // Voucher Details Section
  doc.setFont("times", "normal");
  doc.setFontSize(12);

  // "No." Label with underline
  doc.text("Voucher No.", 20, 70);
  const voucherNo = isDwn?.contactPaymentCode || "VP-018"; // Dynamic voucher number
  doc.text(voucherNo, 50, 70);
  doc.line(45, 71, 80, 71); // Draw line below the voucher number

  // "Date:" Label with underline
  doc.text("Date:", 150, 70);
  const voucherDate = new Date().toLocaleDateString();
  doc.text(voucherDate, 170, 70);
  doc.line(170, 71, 200, 71); // Draw line below the date

  // Rupees Section (No line below this section)
  const amountReceived = isDwn?.amountReceievd?.toFixed(2) || "0.00"; // Dynamic amount received
  doc.text(`Amount: `, 20, 85);
  doc.text(` ${amountReceived}`, 57, 85);
  doc.line(55, 87, 190, 87); // 

  const amountInWords = convertNumberToWords(isDwn?.amountReceievd || 0); // Convert amount to words
  doc.text(`Amount in Words: `, 20, 95);
  doc.text(` ${amountInWords} only`, 57, 95);
  doc.line(55, 97, 190, 97); // Draw line below the date


  // Payment Method Section
  // doc.text("Payment Method:", 20, 100);
  // const paymentMethod = isDwn?.paymentMode || "Cash"; // Default to "Cash" if not defined
  // doc.text(paymentMethod, 105, 100, { align: "center" });

  // Additional Details Section
  doc.text(`Payment Method : `, 20, 105);
  doc.text(` ${isDwn?.paymentMode} `, 57, 105,);
  doc.line(55, 107, 190, 107); // Line below additional details

  // Particulars Section
  
  // doc.text("Particulars: ______________________________________________________", 20, 115);

  // Paid To Section
  const amountPaidTo = isDwn?.companyName || "";
//   doc.text(amountPaidTo, 105, 110, { align: "left" });
  doc.text(`Paid to:`, 20, 115);
  doc.text(`${amountPaidTo}`, 57, 115);
  doc.line(55, 117, 190, 117); // Line below additional details
  
  doc.text(`On Account of:`, 20, 125);
  // doc.text(`_____________________________________________________`, 57, 115);
  doc.line(55, 127, 190, 127); // Line below additional details

  // Amount Section
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  // const amountReceived = isDwn?.amountReceievd?.toFixed(2) || "0.00"; // Dynamic amount received
  // doc.text(`Rs. ${amountReceived}`, 20, 150);

  // Footer Section - Signatures
  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");
  doc.text("Authorized By", 20, 190);
  doc.text("Received By", 160, 190);

  // Draw a box for "Received Payment"
  // doc.rect(150, 160, 40, 20); // x, y, width, height

  // Save PDF
  // doc.output('dataurlnewwindow');
  doc.save("Paymentvoucher.pdf");
};





const amountInWords = convertNumberToWords(isDwn?.amountReceievd || 0);

const summary = (
  <>
    <div
      className="card  card-borderless mb-3 p-2"
      style={{ boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px" }}
    >
      <p className="mt-1">
        <b>Payment Summary</b>
      </p>
      <div className="row">
        {summaryval.map((x) => (
          <div className="col-md-3" key={x.title}>
            <div className="d-flex ps-2">
              <IcomoonReact
                iconSet={iconSet}
                color={x.color}
                size={20}
                icon={x.icon}
                className="mt-1"
              />
              <p className="ms-3">
                {x.title}
                <br />
                <b>
                  {x.title === "No of Expenses"
                    ? `${x.count} `
                    : `${GlobalVariable.userDet.tenantConfig.currency} ${x.amount.toFixed(
                        2
                      )}`}
                </b>
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </>
);

const exportToExcel = () => {
    const fileName = "purchase_data.xlsx";
    const fieldsToExport = [

      "coaName",
      "companyName",
      "firstName",
      "lastName",
      "contactType",
      "paymentCategory",
      "paymentMode",
      "amountReceievd",
      
    ];
    const filteredData = rowData.map((item) => {
      const filteredItem = {};
      fieldsToExport.forEach((field) => {
        filteredItem[field] = item[field];
      });
      return filteredItem;
    });
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Purchase Data");
    XLSX.writeFile(wb, fileName);
  };
const fetchDocuments = (e, datas) => {
  e.stopPropagation();
  setIsView(true);
  setIsDwn(datas);
};
    useEffect(() => {
      GetContactPaymentListSearch(page, sizePerPage, searchVal,"", "");
      GetTenantDetails();
      GetPurchaseExpenseSumnmary();
    }, [])

    useEffect(() => {
      GetContactPaymentListSearch(page, sizePerPage, searchVal,"", "");
    }, [isPaymentVoucher])
    

return (
  !isPaymentVoucher ? 
  (<div className="col-md-12">
        <div className="card card-borderless cc-greyCard-custm mb-3">
          <div className="ms-2 mt-2 me-2">
            <div className="d-flex justify-content-between flex-wrap align-items-center mb-2">
              <h4 className="m-0">Payment Voucher</h4>
              <div className="d-flex justify-content-between kk-table-header kk-header-sec cc-font-size-14">
               <div className="col">

                {/* <Primedropdown
                  // value={filterGrid}
                  // onChange={(e) => {
                  //   changeGridDatasBasedOnStatus(e.value);
                  // }}
                  // options={items}
                  optionLabel="label"
                  placeholder="Select status to filter"
                  className="col-auto text-start me-3 my-auto"
                /> */}

                  <Space.Compact className="me-2">
                    <Input
                      addonBefore={<SearchOutlined />}
                      allowClear={emptySearch}
                      placeholder="Search"
                      value={searchVal}
                      onChange={(e) => keySearch(e)}
                      onKeyUp={(e) => keySearch(e)}
                    />
                  </Space.Compact>
                  {/* <Button
            label="Export"
            icon="pi pi-upload"
            className="py-1 mx-2 kk-btnThin my-auto p-button-help"
            style={{
              backgroundColor: "#dddddd",
              border: "none",
              color: "black",
            }}
            onClick={exportToExcel}
          /> */}
          <button
                    className="btn btn-primary py-1 me-2 kk-btnThin my-2"
                    style={{
                                  // backgroundColor: "#dddddd",
                                  border: "none",
                                  color: "black !important",
                                }}
                    onClick={exportToExcel}
                  >
                    {" "}
                     Export
                  </button>
                  <button
                  className="btn btn-primary py-1 me-2 kk-btnThin my-2"
                  onClick={() => {
                      setIsPaymentVoucher(true);
                      setViewRowData("");
                  }}
                >
                  {" "}
                  <i className="pi pi-plus"></i> New Voucher
                </button>
                {/* <button
                  type="button"
                  className="btn btn-danger py-1 me-2 "
                >
                  {" "}
                  Back
                </button> */}
               </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white shadow-sm chart-of-account h-100 cc-greyCard-custm1">
          <div className="row coa-header kk-header-sec">
            <div className="col-auto header-right ms-auto"></div>
          </div>
        <div className="account-table">
                       {summary}
         
          <DataTable
            // className=" cc-greyCard-custm1"
            value={rowData}
            // responsiveLayout="scroll"
            stripedRows
            size="small"
            loading={isProcess}
            paginator
            lazy
            totalRecords={totalRecords}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rowsPerPageOptions={[10, 20, 50, totalRecords]}
            first={first1}
            rows={sizePerPage}
            onPage={onCustomPage1}
            onSort={onSort}
            sortField={lazyParams.sortField}
            sortOrder={lazyParams.sortOrder}
            onRowClick={handleRowClick}
          >
            <Column
              field="companyName"
              header="Company Name"
              style= {{width:"20%"}}
              // body={nameFormBodyTemplate}
            />
            <Column
                field="firstName"
                header="Vendor"
                style= {{width:"20%"}}
                body ={(a) => a.firstName + " " + a.lastName}
                // body={nameFormBodyTemplate}
              />
              <Column
                field="coaName"
                header="Account"
                // body={nameFormBodyTemplate}
              />
            {/* <Column
              field="COAName"
              header="Account"
              // body={dateFormBodyTemplate}
            /> */}
            <Column field="contactPaymentCode" header=" Payment Code" />
            <Column field="paymentDate" header="Payment Date  " body={dateFormBodyTemplate}/>
            <Column field="paymentMode" header="Payment Mode" />
            {/* {dynamicColumns} */}
            <Column
              field="amountReceievd"
              header="Amount Receievd"
              className="text-end amount-align"
              body = {(a) => GlobalVariable.userDet.tenantConfig.currency +" "+ a.amountReceievd.toFixed(2)}

              // body={(e) => renderStatusColumn(e)}
            ></Column>
            
            
            <Column
            field="actionBodyTemplate"
            header="Action"
            body={actionBodyTemplate}
          />
          </DataTable>
          {/* {isProcess && (
            <ProgressSpinner
              style={{
                width: "50px",
                height: "50px",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
              strokeWidth="2"
              fill="var(--surface-ground)"
              animationDuration=".5s"
            />
          )} */}
        </div>
          
        </div>
        {/*</div> */}
        
        <Dialog
      header={
        <div className="d-flex justify-content-between align-items-center">
          <span><strong>PAYMENT VOUCHER</strong></span>
          <button className="btn btn-light mx-2" onClick={handleDownload}>
            <i className="pi pi-download" style={{ fontSize: '1.1rem' }}></i>
          </button>
        </div>
      }
      visible={isView}
      style={{ width: '50vw' }}
      onHide={() => setIsView(false)}
    >

      <div className="voucher-container p-4 border mt-4">
         <div className="p-3 mb-3 card-bill">
                        <p className="m-0">
                          <strong>{tenantDetails.tenantName},</strong>
                        </p>
                        <p className="m-0 ps-2">
                          {tenantDetails.billAddress1},{" "}
                          {tenantDetails.billAddress2}
                        </p>

                        <p className="m-0 ps-2">
                          <strong className="me-2">
                            <i className="pi pi-home"></i>
                          </strong>{" "}
                          {tenantDetails.billCity} - {tenantDetails.billZipCode}{" "}
                          - {tenantDetails.billCountry}
                        </p>
                        <p className="m-0 ps-2">
                          <strong className="me-2">
                            <i className="pi pi-phone"></i>
                          </strong>{" "}
                          {tenantDetails.primaryPhone},{" "}
                          <strong className="m-2">
                            <i className="pi pi-envelope"></i>
                          </strong>{" "}
                          {tenantDetails.email}
                        </p>
                      </div>
        <div className="row mb-3">
          <div className="col-3">
            <strong>Voucher No:</strong> 
          </div>
          <div className="col-6 ">
          {isDwn?.contactPaymentCode}
          </div>
          <div className="col-3 text-end">
            <strong>Date:</strong> {new Date().toLocaleDateString()}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-3"><strong>Amount:</strong></div>
          <div className="col-6 ">
          {GlobalVariable.userDet.tenantConfig.currency} {isDwn?.amountReceievd?.toFixed(2)} 
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-3"><strong>Payment Method:</strong></div>
          <div className="col-6 ">{isDwn?.paymentMode}</div>
        </div>

        <div className="row mb-3">
          <div className="col-3"><strong>Amount Paid To:</strong></div>
          <div className="col-6 ">{isDwn?.companyName}</div>
        </div>

        <div className="row mb-3">
          <div className="col-3"><strong>Amount in Words:</strong></div>
          <div className="col-6 ">{amountInWords}</div>
        </div>

        <div className="row mb-3">
          <div className="col-3"><strong>On Account of:</strong></div>
          {/* <div className="col-6 ">{isDwn?.coaName}</div> */}
        </div>

        <div className="row mt-5">
          <div className="col-6 text-start">
            {/* <hr className="w-75" /> */}
            <strong>Authorized By</strong>
          </div>
          <div className="col-6 text-end">
            {/* <hr className="w-75" /> */}
            <strong>Received By</strong>
          </div>
        </div>
      </div>
    </Dialog>

      
      </div> ) : <ReceiptVoucherForm data={{setIsReceiptVoucher:handleBackButtonClick, viewRowData:viewRowData}} />
    
  )
}

export default ReceiptVoucher